// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IContactUsApi,
  IContactUsApiGetAttrs,
  IContactUsApiGetResponse,
  IContactUsApiRequest,
  IContactUsApiUpdateAttrs,
  IContactUsApiUpdateResponse,
} from 'interfaces/back-office/content-management/contact-us/contact-us/contact-us-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'
import { IBaseApiRequestPayload } from 'interfaces/api'

export class ContactUsApi extends BaseApi<IContactUsApi> implements IContactUsApiRequest {
  readonly url = ApiConstant.CONTENT_CONTACT_US_URL
  private contactUsUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get Contact Us
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IContactUsApiGetAttrs} payload
   *
   * @return {Promise<IContactUsApiGetResponse>} Promise<IContactUsApiGetResponse>
   */
  async contactUs_get(payload: IContactUsApiGetAttrs): Promise<IContactUsApiGetResponse> {
    try {
      const response = await this.POST(`${this.contactUsUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Update Contact Us
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IContactUsApiUpdateAttrs} payload
   *
   * @return {Promise<IContactUsApiUpdateResponse>} Promise<IContactUsApiUpdateResponse>
   */
  async contactUs_update(payload: IContactUsApiUpdateAttrs): Promise<IContactUsApiUpdateResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: `${this.contactUsUrl}/update`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
